module.exports = __webpack_public_path__ + "yeni h.k. 1.jpg?d729073b308466e48af3fd6df85cf89d";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni h.k. 1.jpg
// module id = 395
// module chunks = 0